import React, { useCallback, useContext, useMemo } from 'react'
import { noop } from 'lodash'
import NavigationMessageHandler from './components/NavigationMessageHandler'

const DEFAULT_CONTEXT = {
  openDeepLink: noop,
}

const DeepLinkHandlerContext = React.createContext(DEFAULT_CONTEXT)
export const Consumer = DeepLinkHandlerContext.Consumer
const Provider = DeepLinkHandlerContext.Provider

export const DeepLinkHandlerProvider = ({ children = null }) => {
  const openDeepLinkCallback = useCallback(link => {
    const url = new URL(link)

    // !!!: Only one type of deep link is output from the API at this time.
    // !!!: Deep links require explicit handling in this project. This may
    //      become unwieldy and need to be refactored/abstracted in the future.
    if (url.host === 'inbox') {
      // Parse the contact ID from the URL
      // !!!: This may change depending on the URL structure
      const contactId = url.pathname.match(/(?!\/conversation\/)(\d)+/g)?.[0]

      if (contactId) {
        // Route to the conversation with the given ID
        window.viewConversation(contactId)
      }
    }
  }, [])

  const contextValue = useMemo(
    () => ({
      openDeepLink: openDeepLinkCallback,
    }),
    [openDeepLinkCallback],
  )

  return (
    <Provider value={contextValue}>
      <NavigationMessageHandler>{children}</NavigationMessageHandler>
    </Provider>
  )
}

export const useDeepLinkHandlerContext = () => {
  return useContext(DeepLinkHandlerContext)
}

export default DeepLinkHandlerContext
